import { render, staticRenderFns } from "./QuizList.vue?vue&type=template&id=6ac2f38b&scoped=true&"
import script from "./QuizList.vue?vue&type=script&lang=ts&"
export * from "./QuizList.vue?vue&type=script&lang=ts&"
import style0 from "./QuizList.vue?vue&type=style&index=0&id=6ac2f38b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2f38b",
  null
  
)

export default component.exports